import React from "react";
import Card from "components/card";
import { useNavigate } from "react-router-dom";
import { 
  MdOutlineProductionQuantityLimits, // For Piecesline
  MdOutlinePeople, // For Manual operations
  MdSettings, // For Mechanical operations
  MdFilterList, // For Sorting
  MdInventory, // For Packaging
  MdOutlineAutoMode, // For Mechanical shelling
  MdLocalShipping, // For Finished Product Warehouse
  MdVerifiedUser, // For Quality Assurance
  MdAssessment, // For Performance KPI
} from "react-icons/md";

export const Departments = () => {
  const navigate = useNavigate();

  const handleDepartmentClick = (dept) => {
    if (dept.path === "#") return;
    // Store the selected department name
    localStorage.setItem('selectedDepartment', dept.name);
    // Navigate to the department's path
    navigate(dept.path);
  };

  const departments = [
    {
      id: 1,
      name: "RCN Warehouse",
      icon: <MdInventory className="h-12 w-12" />,
      path: "/auth/sign-in",
      description: "Warehouse Management",
      color: "bg-gradient-to-br from-blue-500 to-blue-600",
    },
    {
      id: 2,
      name: "Piecesline",
      icon: <MdOutlineProductionQuantityLimits className="h-12 w-12" />,
      path: "#",
      description: "Production Line Management",
      color: "bg-gradient-to-br from-green-500 to-green-600",
    },
    {
      id: 3,
      name: "Manual Peeling",
      icon: <MdOutlinePeople className="h-12 w-12" />,
      path: "/auth/sign-in",
      description: "Manual Peeling Operations",
      color: "bg-gradient-to-br from-purple-500 to-purple-600",
    },
    {
      id: 4,
      name: "Manual Polish",
      icon: <MdOutlinePeople className="h-12 w-12" />,
      path: "#",
      description: "Manual Polishing Operations",
      color: "bg-gradient-to-br from-orange-500 to-orange-600",
    },
    {
      id: 5,
      name: "Mechanical Peeling",
      icon: <MdSettings className="h-12 w-12" />,
      path: "#",
      description: "Mechanical Peeling Process",
      color: "bg-gradient-to-br from-red-500 to-red-600",
    },
    {
      id: 6,
      name: "Mechanical Polish",
      icon: <MdSettings className="h-12 w-12" />,
      path: "#",
      description: "Mechanical Polishing Process",
      color: "bg-gradient-to-br from-yellow-500 to-yellow-600",
    },
    {
      id: 7,
      name: "Table Sorting",
      icon: <MdFilterList className="h-12 w-12" />,
      path: "#",
      description: "Table Sorting Operations",
      color: "bg-gradient-to-br from-teal-500 to-teal-600",
    },
    {
      id: 8,
      name: "Manual Sorting",
      icon: <MdOutlinePeople className="h-12 w-12" />,
      path: "#",
      description: "Manual Sorting Process",
      color: "bg-gradient-to-br from-indigo-500 to-indigo-600",
    },
    {
      id: 9,
      name: "Packaging",
      icon: <MdInventory className="h-12 w-12" />,
      path: "#",
      description: "Product Packaging Operations",
      color: "bg-gradient-to-br from-pink-500 to-pink-600",
    },
    {
      id: 10,
      name: "Mechanical Shelling",
      icon: <MdOutlineAutoMode className="h-12 w-12" />,
      path: "#",
      description: "Mechanical Shelling Process",
      color: "bg-gradient-to-br from-cyan-500 to-cyan-600",
    },
    {
      id: 10,
      name: "Finished Product Warehouse",
      icon: <MdLocalShipping className="h-12 w-12" />,
      path: "/auth/sign-in",
      description: "Finished Product Warehouse Management",
      color: "bg-gradient-to-br from-red-500 to-red-600",
    },
    {
      id: 11,
      name: "Quality Assurance",
      icon: <MdVerifiedUser className="h-12 w-12" />,
      path: "/auth/sign-in",
      description: "Quality Assurance Management",
      color: "bg-gradient-to-br from-red-500 to-red-600",
    },
    {
      id: 12,
      name: "Performance KPI",
      icon: <MdAssessment className="h-12 w-12" />,
      path: "/performance-kpi/login",
      description: "Performance Management & KPI Tracking",
      color: "bg-gradient-to-br from-emerald-600 to-emerald-800",
    },
  ];

  return (
    <div className="flex min-h-screen items-center justify-center bg-lightPrimary dark:bg-navy-900">
      <div className="mx-auto w-full max-w-7xl p-4">
        {/* Welcome Banner */}
        <div className="mb-12 text-center">
          {/* <img 
            src="https://usibras.com/wp-content/uploads/2021/06/logo-usibras.png" 
            alt="Usibras Logo" 
            className="mx-auto mb-8 h-20"
          /> */}
          <h1 className="mb-3 text-4xl font-bold text-navy-700 dark:text-white">
            Welcome to Usibras Ghana Limited
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-400">
            Sign into your Department
          </p>
        </div>

        {/* Departments Grid */}
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {departments.map((dept) => (
            <Card
              key={dept.id}
              extra={`flex cursor-pointer flex-col overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-2xl`}
              onClick={() => handleDepartmentClick(dept)}
            >
              <div className={`${dept.color} p-6`}>
                <div className="flex items-center justify-center text-white">
                  {dept.icon}
                </div>
              </div>
              <div className="p-6 text-center">
                <h4 className="mb-2 text-2xl font-bold text-navy-700 dark:text-white">
                  {dept.name}
                </h4>
                <p className="text-base text-gray-600 dark:text-gray-400">
                  {dept.description}
                </p>
              </div>
            </Card>
          ))}
        </div>

        {/* Footer */}
        <div className="mt-12 text-center">
          <p className="text-sm text-gray-600 dark:text-gray-400">
            © {new Date().getFullYear()} Usibras Ghana Limited. All rights reserved.
          </p>
          <p className="mt-2 text-xs text-gray-500 dark:text-gray-500">
            Powered by{' '}
            <a 
              href="https://www.sangeotechnologies.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 underline transition-colors"
            >
              Sangeo Technologies
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Departments;